import { render, staticRenderFns } from "./ExportTxtConfig.vue?vue&type=template&id=52fb7d04&"
import script from "./ExportTxtConfig.vue?vue&type=script&lang=js&"
export * from "./ExportTxtConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports